import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import POSDashboard from './components/POSDashboard';
import GlobalConfig from './config/global';
import { enterFullscreen } from './utils/fullscreen';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('posTheme') || 'light';
  });

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('posTheme', newTheme);
  };

  useEffect(() => {
    // Check if user is already logged in
    if (GlobalConfig.token && GlobalConfig.user) {
      setIsLoggedIn(true);
      setUserData({
        employer: GlobalConfig.user,
        current_shift: GlobalConfig.currentShift
      });
      enterFullscreen();
    }
  }, []);

  const handleLogin = (loginData) => {
    setUserData(loginData);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserData(null);
  };

  return (
    <div className={`App ${theme === 'dark' ? 'dark-mode' : ''}`}>
      {!isLoggedIn ? (
        <Login onLogin={handleLogin} />
      ) : (
        <POSDashboard userData={userData} onLogout={handleLogout} toggleTheme={toggleTheme} theme={theme} />
      )}
    </div>
  );
}

export default App;